import axios from 'axios';
import * as actionTypes from './actionTypes';
import {clientsFail, clientsLoading, clientsSuccess} from "./clients";

export const countResellersLoading = () => {
    return {
        type: actionTypes.COUNT_RESELLERS_LOADING
    }
};

export const countResellersFail = (error) => {
    return {
        type: actionTypes.COUNT_RESELLERS_FAIL,
        error: error
    }
};

export const countResellersSuccess = (data) => {
    return {
        type: actionTypes.COUNT_RESELLERS_SUCCESS,
        payload: data
    }
};

export const countDealersLoading = () => {
    return {
        type: actionTypes.COUNT_DEALERS_LOADING
    }
};

export const countDealersFail = (error) => {
    return {
        type: actionTypes.COUNT_DEALERS_FAIL,
        error: error
    }
};

export const countDealersSuccess = (data) => {
    return {
        type: actionTypes.COUNT_DEALERS_SUCCESS,
        payload: data
    }
};

export const countAllClientsLoading = () => {
    return {
        type: actionTypes.COUNT_ALL_CLIENTS_LOADING
    }
};

export const countAllClientsFail = (error) => {
    return {
        type: actionTypes.COUNT_ALL_CLIENTS_FAIL,
        error: error
    }
};

export const countAllClientsSuccess = (data) => {
    return {
        type: actionTypes.COUNT_ALL_CLIENTS_SUCCESS,
        payload: data
    }
};

export const countActiveClientsLoading = () => {
    return {
        type: actionTypes.COUNT_ACTIVE_CLIENTS_LOADING
    }
};

export const countActiveClientsFail = (error) => {
    return {
        type: actionTypes.COUNT_ACTIVE_CLIENTS_FAIL,
        error: error
    }
};

export const countActiveClientsSuccess = (data) => {
    return {
        type: actionTypes.COUNT_ACTIVE_CLIENTS_SUCCESS,
        payload: data
    }
};

export const countExpiredClientsLoading = () => {
    return {
        type: actionTypes.COUNT_EXPIRED_CLIENTS_LOADING
    }
};

export const countExpiredClientsFail = (error) => {
    return {
        type: actionTypes.COUNT_EXPIRED_CLIENTS_FAIL,
        error: error
    }
};

export const countExpiredClientsSuccess = (data) => {
    return {
        type: actionTypes.COUNT_EXPIRED_CLIENTS_SUCCESS,
        payload: data
    }
};

export const countTrialsLoading = () => {
    return {
        type: actionTypes.COUNT_TRIALS_LOADING
    }
};

export const countTrialsFail = (error) => {
    return {
        type: actionTypes.COUNT_TRIALS_FAIL,
        error: error
    }
};

export const countTrialsSuccess = (data) => {
    return {
        type: actionTypes.COUNT_TRIALS_SUCCESS,
        payload: data
    }
};

export const countMinistraLoading = () => {
    return {
        type: actionTypes.COUNT_MINISTRA_LOADING
    }
};

export const countMinistraFail = (error) => {
    return {
        type: actionTypes.COUNT_MINISTRA_FAIL,
        error: error
    }
};

export const countMinistraSuccess = (data) => {
    return {
        type: actionTypes.COUNT_MINISTRA_SUCCESS,
        payload: data
    }
};

export const countResellersAdmin = (token) => {
    return dispatch => {

        dispatch(countResellersLoading());
        axios.get('/admin/totalresellers?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countResellersSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countResellersFail(message));
        });
    }
};

export const countDealersAdmin = (token) => {
    return dispatch => {

        dispatch(countDealersLoading());
        axios.get('/admin/totaldealers?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countDealersSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countDealersFail(message));
        });
    }
};

export const countDealersSuperResellers = (token) => {
    return dispatch => {

        dispatch(countDealersLoading());
        axios.get('/superreseller/totaldealers?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countDealersSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countDealersFail(message));
        });
    }
};

export const countAllClientsAdmin = (token) => {
    return dispatch => {

        dispatch(countAllClientsLoading());
        axios.get('/admin/totalclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countAllClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countAllClientsFail(message));
        });
    }
};

export const countAllClientsSuperResellers = (token) => {
    return dispatch => {

        dispatch(countAllClientsLoading());
        axios.get('/superreseller/totalclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countAllClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countAllClientsFail(message));
        });
    }
};

export const countAllClientsResellers = (token) => {
    return dispatch => {

        dispatch(countAllClientsLoading());
        axios.get('/reseller/totalclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countAllClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countAllClientsFail(message));
        });
    }
};


export const countActiveClientsAdmin = (token) => {
    return dispatch => {

        dispatch(countActiveClientsLoading());
        axios.get('/admin/totalactiveclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countActiveClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countActiveClientsFail(message));
        });
    }
};

export const countActiveClientsSuperResellers = (token) => {
    return dispatch => {

        dispatch(countActiveClientsLoading());
        axios.get('/superreseller/totalactiveclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countActiveClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countActiveClientsFail(message));
        });
    }
};

export const countActiveClientsResellers = (token) => {
    return dispatch => {

        dispatch(countActiveClientsLoading());
        axios.get('/reseller/totalactiveclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countActiveClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countActiveClientsFail(message));
        });
    }
};

export const countActiveClientsDealer = (token) => {
    return dispatch => {

        dispatch(countActiveClientsLoading());
        axios.get('/api/totalactiveclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countActiveClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countActiveClientsFail(message));
        });
    }
};

export const countExpiredClientsAdmin = (token) => {
    return dispatch => {

        dispatch(countExpiredClientsLoading());
        axios.get('/admin/totalexpiredclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countExpiredClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countExpiredClientsFail(message));
        });
    }
};

export const countExpiredClientsSuperResellers = (token) => {
    return dispatch => {

        dispatch(countExpiredClientsLoading());
        axios.get('/superreseller/totalexpiredclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countExpiredClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countExpiredClientsFail(message));
        });
    }
};

export const countExpiredClientsResellers = (token) => {
    return dispatch => {

        dispatch(countExpiredClientsLoading());
        axios.get('/reseller/totalexpiredclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countExpiredClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countExpiredClientsFail(message));
        });
    }
};

export const countExpiredClientsDealer = (token) => {
    return dispatch => {

        dispatch(countExpiredClientsLoading());
        axios.get('/api/totalexpiredclients?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countExpiredClientsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countExpiredClientsFail(message));
        });
    }
};

export const countTrialsAdmin = (token) => {
    return dispatch => {

        dispatch(countTrialsLoading());
        axios.get('/admin/totalactivetrials?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countTrialsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countTrialsFail(message));
        });
    }
};

export const countTrialsSuperResellers = (token) => {
    return dispatch => {

        dispatch(countTrialsLoading());
        axios.get('/superreseller/totalactivetrials?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countTrialsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countTrialsFail(message));
        });
    }
};

export const countTrialsResellers = (token) => {
    return dispatch => {

        dispatch(countTrialsLoading());
        axios.get('/reseller/totalactivetrials?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countTrialsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countTrialsFail(message));
        });
    }
};

export const countTrialsDealer = (token) => {
    return dispatch => {

        dispatch(countTrialsLoading());
        axios.get('/api/totalactivetrials?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countTrialsSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countTrialsFail(message));
        });
    }
};

export const countMinistraAdmin = (token) => {
    return dispatch => {

        dispatch(countMinistraLoading());
        axios.get('/admin/totalactiveministra?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countMinistraSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countMinistraFail(message));
        });
    }
};

export const countMinistraSuperResellers = (token) => {
    return dispatch => {

        dispatch(countMinistraLoading());
        axios.get('/superreseller/totalactiveministra?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countMinistraSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countMinistraFail(message));
        });
    }
};

export const countMinistraResellers = (token) => {
    return dispatch => {

        dispatch(countMinistraLoading());
        axios.get('/reseller/totalactiveministra?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countMinistraSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countMinistraFail(message));
        });
    }
};

export const countMinistraDealer = (token) => {
    return dispatch => {

        dispatch(countMinistraLoading());
        axios.get('/api/totalactiveministra?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(countMinistraSuccess(res.data));
            }).catch(error => {
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(countMinistraFail(message));
        });
    }
};
